module.exports = __webpack_public_path__ + "static/media/sub-gift.339821d6.png";